import React from 'react';
import AvailablePolls from './components/user/available_polls'
import Poll from './components/user/poll'
import Signin from './components/user/sign_in'
import './App.css'

class App extends React.Component {
    state = {
        auth: false,
        data: [],
    }

    changeData = (info) => {
        this.setState({
            data: info
        })
    }

    handleAuthState = (data) => {
        console.log("inisde handleStateAuth")
        this.setState({
            auth: true,
            user_data: data
        })
    }

    authFalse = () => {
        this.setState({
            auth: false
        })
    }

    setPoll = (pollId) => {
        console.log("inside setPoll")
        let onePoll = this.state.data.filter((arr) => {
            return arr._id === pollId
        })
        this.setState({
            selectPoll: onePoll
        })
    }

    clearState = () => {
        this.setState({
            data: [],
            selectPoll: undefined,
            user_data: {}
        })
    }

    render() {
        if (!this.state.auth) {
            return (
                <Signin handleAuthState={this.handleAuthState} />
            )
        } else {
            if (this.state.selectPoll === undefined) {
                return (
                    <>
                        <AvailablePolls data={this.state.data} setPoll={this.setPoll} changeData={this.changeData} user_data={this.state.user_data} />
                    </>
                )
            } else {
                return (
                    <>
                        <Poll selectPoll={this.state.selectPoll} user_data={this.state.user_data} authFalse={this.authFalse} clearState={this.clearState}/>
                    </>
                )
            }
        }
    }
}

export default App;